import React from "react";
import Logo from "../../../Assets/Images/logo.svg";
import TwitterIcon from "@mui/icons-material/Twitter";
import { Typography, Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { FooterContainer, styles } from "./styles";
import { Link, useNavigate } from "react-router-dom";
import paths from "../../../Infrastructure/Router/paths";

const Footer = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  const handleNavigation = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, left: 0 })
  }
  return (
    <>
      <FooterContainer  className="site-footer">
        <Grid container spacing={3}>
          {/* Sub Grid 1 */}
          <Grid xs={12} sm={12} md={12} lg={6} sx={styles.subGrid1}>
            <Box sx={styles.subGrid1Box}>
              <Box sx={{ cursor: "pointer" }} onClick={() => handleNavigation(paths.home.path)}>
                <img src={Logo} height="50px" alt=""
                  style={{
                    filter: "invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg)"
                  }}
                />
              </Box>
              <Typography variant="h1" sx={styles.subGrid1BoxTypo}>
                Education for Everyone
              </Typography>
            </Box>
            <Typography
              variant="h1"
              className="container"
              sx={styles.subGrid1Typo}
            >
              © {currentYear} Vulcan Learning Institute LLC
            </Typography>
          </Grid>

          {/* Sub Grid 2 */}
          <Grid
            xs={10}
            sm={11}
            md={11}
            lg={5}
            sx={styles.subGrid2}
            display="flex"
            justifyContent="space-around"
            alignItems="center"
            flexWrap={'wrap'}
          >
            <Typography
              variant="h6"
              sx={styles.subGrid2Typo}
              onClick={() => handleNavigation(paths.policiesPage.path)}
            >
              Policies
            </Typography>
            <Typography
              variant="h6"
              sx={styles.subGrid2Typo}
              onClick={() => handleNavigation(paths.cancellationPage.path)}
            >
              Cancellation
            </Typography>

            <Typography
              variant="h6"
              sx={styles.subGrid2Typo}
              onClick={() => handleNavigation(paths.privacyPage.path)}
            >
              Privacy
            </Typography>

            <Typography
              variant="h6"
              sx={styles.subGrid2Typo}
              onClick={() => handleNavigation(paths.contactPage.path)}
            >
              Contact
            </Typography>
            <Typography
              variant="h6"
              sx={styles.subGrid2Typo}
              onClick={() => handleNavigation(paths.careersPage.path)}
            >
              Careers
            </Typography>
          </Grid>

          {/* Sub Grid 3 */}
          <Grid
            xs={2}
            sm={1}
            md={1}
            lg={1}
            sx={styles.subGrid3}
          >
            <Link
              to="https://twitter.com/vulcaninstitute"
              target="_blank"
              rel="noopener noreferrer"
            >
              <TwitterIcon
                fontSize="large"
                className="twticon"
                sx={{
                  ...styles.subGrid3Icon,
                  color: (theme) => theme.palette.primary.main,
                }}
              />
            </Link>
          </Grid>
        </Grid>
      </FooterContainer>
    </>
  );
};

export default Footer;
